/**
 * Politique de mot de passe — MIROIR CLIENT de `validatePassword` (server/authz.js).
 *
 * Le serveur reste la seule autorité (chaque requête y est revalidée) ; ce
 * module existe pour que l'utilisateur voie POURQUOI son mot de passe est refusé
 * AVANT d'envoyer, au lieu de découvrir un aller-retour d'erreur.
 * Garder les deux en phase : même minimum, mêmes classes, même liste de mots
 * prévisibles.
 */
export const PASSWORD_MIN = 10;
export const PASSWORD_MAX = 200;

const CLASSES = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/];
const PREDICTABLE = /^(password|bandz|kadebostany|azerty|qwerty|123456)/i;

export interface PasswordCheck {
  tooShort: boolean;
  tooLong: boolean;
  weakMix: boolean;
  predictable: boolean;
  ok: boolean;
}

export function checkPassword(pw: string): PasswordCheck {
  const value = typeof pw === 'string' ? pw : '';
  const classes = CLASSES.filter((re) => re.test(value)).length;
  const tooShort = value.length < PASSWORD_MIN;
  const tooLong = value.length > PASSWORD_MAX;
  const weakMix = classes < 3;
  const predictable = PREDICTABLE.test(value);
  return {
    tooShort,
    tooLong,
    weakMix,
    predictable,
    ok: !tooShort && !tooLong && !weakMix && !predictable,
  };
}
